<template>
  <div class="">
    <custom-dialog :title="$t('crm_deviceAcrapDialog.xzspjg')" :visible="visible" :appendToBody="true" v-on="$listeners" width="400px">
      <div class="dialog-body device-acrap-dialog">
        <!-- <div class="tip">
          <i class="icon icon-tishi"></i>
          <span>{{ $t('page_content_tips_timer') }}</span>
        </div> -->
        <el-form :model="form" :inline="true" ref="form" label-width="120px">
          <el-row>
            <el-form-item :label="$t('crm_deviceAcrapDialog.shen_pi_jie_guo')" prop="returnType" :rules="rules.returnType">
              <custom-select v-model="form.returnType" code="dms_scrap_return_type" width="100%" :placeholder="$t('Common.com_please_select')" :disabled="model.type === 'watch'"></custom-select>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveContact">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  data() {
    return {
      visible: false,
      form: { returnType: '' },
    };
  },
  computed: {
    rules() {
      return {
        returnType: [{ required: true, message: this.$t('Common.com_required') }],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('success');
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.form.scrapApplyId = this.model.scrapApplyId;
        this.$postJSON(apis.deviceScrapSetReturnType, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          this.closeDialog();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.device-acrap-dialog {
  .tip {
    background: #fef4db;
    margin-bottom: 10px;
    padding-left: 10px;
    margin-right: 8px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
